import { ROUTES } from './routes'

/**
 * `/_/email/unsubscribe/{token}`: the page the footer of an F-104 notice opens
 * ("Não quero mais avisos de <categoria>"). Public, no session: the signed
 * token is the credential and turns off that one category.
 */
export const isEmailUnsubscribePath = (path: string): boolean => path.split('?')[0].startsWith(ROUTES.emailUnsubscribe)

/** A signed token is base64url segments joined by dots; nothing else may reach the API path. */
const TOKEN_PATTERN = /^[A-Za-z0-9_.-]{1,2048}$/

/**
 * The token as it came in the URL, or '' when it isn't a well-formed token.
 * It is interpolated into an API path, so anything that could change the path
 * (`/`, `..`, encoded separators) is refused here, not only escaped.
 */
export const emailUnsubscribeTokenFrom = (path: string): string => {
  const raw = path.split('?')[0].slice(ROUTES.emailUnsubscribe.length).split(/[/#]/)[0] || ''
  let token: string
  try {
    token = decodeURIComponent(raw).trim()
  } catch {
    return ''
  }
  return TOKEN_PATTERN.test(token) && !token.includes('..') ? token : ''
}

/** Minha Conta › E-mails desta comunidade, with a category highlighted. */
export const accountEmailsPath = (category?: string | null): string =>
  category ? `${ROUTES.accountEmails}?category=${encodeURIComponent(category)}` : ROUTES.accountEmails
